/* eslint-disable prefer-template */
import React from 'react';

import ApplicationState from 'store/interfaces';
import Chart from 'chart.js';
import palette from 'theme/palette';
import { connect } from 'react-redux';
import { EnvironmentsCostGraphFields } from 'modules/monitor/interfaces';
import { Grid } from '@material-ui/core';
import { formatCurrency } from 'utils/helpers';

interface EnvironmentsCostGraphContentProps {
  environmentsCostGraphFields: EnvironmentsCostGraphFields;
}

const EnvironmentsCostGraphContent = ({
  environmentsCostGraphFields,
}: EnvironmentsCostGraphContentProps) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);

  const dateFormat = currentDate => {
    return (
      currentDate.getDate() +
      '/' +
      (currentDate.getMonth() + 1) +
      ' - ' +
      currentDate.toLocaleTimeString('pt-BR', {
        hour12: false,
        hour: 'numeric',
        minute: 'numeric',
      })
    );
  };

  const labels = environmentsCostGraphFields?.metrics?.map(item =>
    dateFormat(new Date(item?.timestamp * 1000))
  );

  const data = {
    labels,
    datasets: [
      {
        data: environmentsCostGraphFields?.metrics?.map(item => item.cost),
        backgroundColor: palette.yellow,
        borderColor: palette.yellow,
        fill: false,
        tension: 0.4,
      },
    ],
  };

  const config = {
    type: 'line',
    data,
    options: {
      scaleShowLabels: false,
      responsive: true,
      legend: {
        display: false,
      },
      tooltips: {
        callbacks: {
          label(tooltipItem) {
            return formatCurrency(tooltipItem.value);
          },
        },
        displayColors: false,
      },
      plugins: {
        legend: {
          display: false,
        },
        filler: {
          propagate: false,
        },
        title: {
          display: false,
        },
      },
      interaction: {
        intersect: true,
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: true,
            },
            ticks: {
              display: true,
              fontSize: 10,
            },
          },
        ],
        yAxes: [
          {
            max: 10,
            gridLines: {
              display: true,
            },
            ticks: {
              display: true,
              fontSize: 10,
            },
          },
        ],
      },
    },
  };

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  return (
    <Grid container>
      <canvas ref={containerRef} width="auto" height="100"></canvas>
    </Grid>
  );
};

const mapStateToProps = ({
  monitor: { environmentsCostGraphFields },
}: ApplicationState) => ({ environmentsCostGraphFields });

export default connect(mapStateToProps, {})(EnvironmentsCostGraphContent);
